import { useState, useEffect, ReactNode } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { AuthContext } from './AuthContext';
import { clearMerchantState } from '../store/slices/merchantSlice';

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps): JSX.Element => {
  const dispatch = useDispatch();
  const [cookies, setCookie, removeCookie] = useCookies([
    'isAuthenticated',
    'role',
    'authToken',
    'refreshToken',
    'loungeId',
    'loungeDetails',
  ]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeAuth = () => {
      if (cookies.isAuthenticated) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
      setIsLoading(false);
    };

    initializeAuth();
  }, [cookies.isAuthenticated]);

  const handleLogin = () => {
    try {
      setIsAuthenticated(true);
      setCookie('isAuthenticated', 'true', { path: '/', secure: true });
    } catch (error) {
      console.error('Error during login:', error);
      setIsAuthenticated(false);
    }
  };

  const handleLogout = () => {
    try {
      setIsAuthenticated(false);
      dispatch(clearMerchantState());
      removeCookie('isAuthenticated', { path: '/' });
      removeCookie('role', { path: '/' });
      removeCookie('authToken', { path: '/' });
      removeCookie('refreshToken', { path: '/' });
      removeCookie('loungeId', { path: '/' });
      removeCookie('loungeDetails', { path: '/' });
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isLoading,
        handleLogin,
        handleLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
